"use client";

import { type FC } from "react";

import { LOCALE_META } from "@/entities/locale";
import { LocaleSelector } from "@/widgets/locale-selector";

export const FixedLocaleSelector: FC = () => (
  <LocaleSelector data={LOCALE_META} className="fixed end-3 top-3 z-[51] md:end-5 md:top-4" />
);
